import { createUseStyles } from "react-jss";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  filter: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    width: "fit-content",
    display: "inline-block",
  },
  selectDates: {
    marginLeft: "20px",
    color: theme.flatpickr.selectDates.color,
    display: "flex",
    alignItems: "center",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginLeft: 0
    }
  },
  icon: {
    display: "flex",
    marginRight: "8px"
  },
  popoverDiv: {
    display: "flex",
    width:"656px",
    backgroundColor: theme.flatpickr.popoverDiv.backgroundColor,
    border: theme.flatpickr.popoverDiv.border,
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    borderRadius: 8,
    color: theme.flatpickr.popoverDiv.color,
    flexDirection: "column",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width:"auto",
    },

    "& input": {
      display: "none"
    },

    "& .flatpickr-calendar": {
      boxShadow: "none"
    },
    "& .flatpickr-current-month": {
      "& .numInputWrapper": {
        [`@media (max-width: ${breakpoints.md}px)`]: {
          "& span": {
            opacity: 1,
          },
        },
      }
    },
  },
  popoverContainer:{
    display:"flex",
    flexDirection:"column",
    alignItems:"center"
  },
  popoverStyle: {
    maxWidth:"656px",
    border: "none",
    "& .popover-arrow": {
      display: "none !important",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      maxWidth: "360px"
    },
  },
  footer: {
    width: "100%",
    padding: '16px',
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingRight: 0
  },
  cancel: {
    height: "44px"
  },
  apply: {
    marginLeft: "10px",
    height: "44px",
  },
  selectedDates: {
    display: "flex",
    padding: 0,
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width:"100%"
    }
  },
  selectedDate: {
    flex: 1,
    border: theme.flatpickr.selectedDate.border,
    borderRadius: "8px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    padding: "14px",
    minWidth: "100px",
    height: "44px",
    fontFamily: theme.fontFamily,
    fontSize:"16px",
    fontWeight:"400",
    lineHeight: "24px",
    color: theme.flatpickr.selectedDate.color,
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      marginBottom:"10px"
    }
  },
  separator: {
    display: "flex",
    alignItems: "center",
    margin: "0px 10px 0"
  },
  active: {
    backgroundColor: theme.flatpickr.active.backgroundColor,
  },
  divider: {
    borderBottom: theme.flatpickr.divider.borderBottom,
    width: "100%",
    left: 0,
    position: "absolute"
  },
  flat: {
    "& input": {
      display: "none"
    },
    "& .flatpickr-calendar": {
      boxShadow: "none",
      margin: "0 24px",
      [`@media (max-width: ${breakpoints.xs}px)`]: {
        margin: "0",
        maxWidth: "267px"
      }
    },
    "& .flatpickr-month": {
      padding: "0 4px",
      margin: "20px 0"
    },
    "& .flatpickr-weekday": {
      color: theme.flatpickr.flatpickrWeekday.color,
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px"
    },
    "& .flatpickr-day.today.startRange, .flatpickr-day.today.endRange": {
      color: theme.flatpickr.day.today.hover.color,
      "&:after": {
        content: '""',
        display: "block",
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        position: "absolute",
        bottom: "4px",
        left: "16px",
      },
      "&:hover:after": {
        backgroundColor: theme.flatpickr.today.after.backgroundColor + "!important",
      }
    },
    "& .flatpickr-prev-month, .flatpickr-next-month": {
      marginTop: "13px",
      padding: "10px 7px"
    },
    "& .flatpickr-day.selected.startRange, .flatpickr-day.selected.endRange": {
      fontWeight: "500",
      backgroundColor: theme.flatpickr.selected.backgroundColor,
      borderColor: theme.flatpickr.borderColor,
      color: theme.flatpickr.day.colorDefault
    },
    "& .flatpickr-day.startRange, .flatpickr-day.endRange": {
      fontWeight: "500",
      backgroundColor: theme.flatpickr.selected.backgroundColor,
      borderColor: theme.flatpickr.borderColor,
      color: theme.flatpickr.day.colorDefault,
      "&:hover": {
        backgroundColor: theme.flatpickr.selected.backgroundColor,
        borderColor: theme.flatpickr.borderColor,
        color: theme.flatpickr.day.colorDefault
      },
    },
    "& .flatpickr-day.today.selected:after": {
      backgroundColor: theme.flatpickr.today.after.backgroundColor,
    },
    "& .flatpickr-day.today:after": {
      content: '""',
      display: "block",
      width: "6px",
      height: "6px",
      backgroundColor: theme.flatpickr.today.after.default.backgroundColor,
      borderRadius: "50%",
      position: "absolute",
      bottom: "4px",
      left: "16px",
    },

    "& .flatpickr-day.hidden": {
      visibility: "visible"
    },
    "& .flatpickr-day.prevMonthDay .flatpickr-day.nextMonthDay": {
      color: theme.flatpickr.day.color,
      fontSize: "14px",
      fontWeight: "400",
    },

    "& .flatpickr-day.prevMonthDay.hidden.selected.endRange": {
        backgroundColor: theme.flatpickr.day.backgroundColor,
        color: theme.flatpickr.day.color,
        border:"none",
        fontSize: "14px",
        fontWeight: "400",
    },

    "& .flatpickr-day.nextMonthDay.hidden.selected.endRange": {
      backgroundColor: theme.flatpickr.day.backgroundColor,
      color: theme.flatpickr.day.color,
      border:"none",
      fontSize: "14px",
      fontWeight: "400",
    },

    "& .flatpickr-day.prevMonthDay.hidden.selected.startRange": {
      backgroundColor: theme.flatpickr.day.backgroundColor,
      color:theme.flatpickr.day.color,
      border:"none",
      fontSize: "14px",
      fontWeight: "400",
    },

    "& .flatpickr-day.nextMonthDay, .flatpickr-day.prevMonthDay": {
      color: theme.flatpickr.day.color,
    },
    "& .flatpickr-day.endRange.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.selected.nextMonthDay": {
      color: theme.flatpickr.day.colorDefault
    },
    
    "& .flatpickr-day.nextMonthDay.hidden.selected.startRange": {
      backgroundColor: theme.flatpickr.day.backgroundColor,
      color: theme.flatpickr.day.color,
      border:"none",
      fontSize: "14px",
      fontWeight: "400",
    },

    "& .flatpickr-days": {
      display: "flex",
      alignItems: "stretch"
    },
    "& .flatpickr-day": {
      fontFamily: theme.fontFamily,
      fontSize: "14px",
      fontWeight: "400",
      marginTop: "3px",
      "&.selected":{
        backgroundColor: theme.flatpickr.selected.backgroundColor,
        borderColor: theme.flatpickr.selected.backgroundColor,
      },
      "&.today": {
        border: "none",
        backgroundColor: theme.flatpickr.day.today.backgroundColor,
        "&:hover:after": {
          backgroundColor: theme.flatpickr.today.after.default.backgroundColor,
        },
        "&:hover": {
          color: theme.flatpickr.day.today.hover.color,
        }
      },
      "&:hover": {
        color: theme.flatpickr.day.today.hover.color,
        borderColor: theme.flatpickr.borderColor,
        background: theme.flatpickr.background,
        fontWeight: "500",
      },
      "&:focus": {
        color: theme.flatpickr.day.today.hover.color,
        borderColor: theme.flatpickr.borderColor,
        background: theme.flatpickr.background,
      },
      "&.inRange": {
        boxShadow: theme.flatpickr.day.inRange.boxShadow,
        fontWeight: "500",
      }
    },
    "& .dayContainer": {
      padding: "0px 24px 20px 0px",
      alignContent: "flex-start",
      [`@media (max-width: ${breakpoints.xs}px)`]: {
        padding:"0px 50px 5px 15px",
      },
    },
    "& .dayContainer + .dayContainer": {
      borderLeft: theme.flatpickr.dayContainer.borderLeft,
      boxShadow: "none",
      padding: "0px 0px 20px 24px",
    },
    "& .flatpickr-weekdaycontainer": {
      fontFamily: theme.fontFamily,
      fontSize: "14px",
      fontWeight: "500",
      padding: "0px 24px 10px 0px",
      [`@media (max-width: ${breakpoints.xs}px)`]: {
        padding:"15px 50px 5px 15px",
      },
    },
    "& .flatpickr-weekdaycontainer + .flatpickr-weekdaycontainer": {
      padding: "0px 0px 10px 24px"
    },
    "& .flatpickr-current-month": {
      fontFamily: theme.fontFamily,
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "24px",
      color: theme.flatpickr.currentMonth.color,
      padding: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& .cur-month, .cur-year": {
        fontFamily: theme.fontFamily,
        fontSize: "16px",
        fontWeight: "600",
        lineHeight: "24px",
        color: theme.flatpickr.currentMonth.color,
      },
    }
  },
}));

export default styles;

